```vue
<template>

  <div class="container-fluid py-4 payment-page">

    <!-- ================= HEADER ================= -->
    <div
      class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap"
    >

      <div class="d-flex align-items-center gap-3">

        <i class="bi bi-credit-card-2-front fs-2 text-success"></i>

        <div>

          <h2 class="fw-bold mb-0">
            Modification moyen de paiement
          </h2>

          <small class="text-white-50">
            Modifier les informations du moyen de paiement
          </small>

        </div>

      </div>


      <router-link
        class="btn btn-success btn-lg shadow-sm btn-boutique"
        :to="{ name: 'liste_moyen_paiement' }"
      >
        <i class="bi bi-arrow-left-circle me-1"></i>
        Retour
      </router-link>

    </div>


    <!-- ================= LOADER ================= -->
    <div
      v-if="loadingData"
      class="text-center my-5"
    >

      <div
        class="spinner-border text-success"
        style="width:3rem;height:3rem;"
      ></div>

      <p class="mt-3">
        Chargement du moyen de paiement...
      </p>

    </div>


    <!-- ================= FORM CARD ================= -->
    <div
      v-else
      class="card shadow-sm rounded card-boutique p-4"
    >

      <div class="row g-4">

        <!-- ================= NOM ================= -->
        <div class="col-md-6">

          <label class="form-label fw-semibold">
            Nom
          </label>

          <input
            type="text"
            v-model="moyen.nom"
            class="form-control form-control-boutique"
            placeholder="Ex: Cash, Wave, Orange Money..."
            :class="{ 'is-invalid': error.nom }"
          />

          <div
            v-if="error.nom"
            class="invalid-feedback"
          >
            {{ error.nom }}
          </div>

        </div>


        <!-- ================= STATUS ================= -->
        <div class="col-md-6 d-flex align-items-center">

          <div class="form-check form-switch mt-3">

            <input
              class="form-check-input"
              type="checkbox"
              v-model="moyen.isEnabled"
              id="isEnabled"
            />

            <label
              class="form-check-label ms-2 fw-semibold"
              for="isEnabled"
            >
              Activé ?
            </label>

          </div>

        </div>

      </div>


      <!-- ================= INFORMATIONS ================= -->
      <div
        v-if="moyen.id"
        class="row mt-4 pt-3 border-top"
      >

        <div class="col-md-6">

          <small class="text-muted">
            Identifiant
          </small>

          <div class="fw-semibold">
            #{{ moyen.id }}
          </div>

        </div>


        <div class="col-md-6">

          <small class="text-muted">
            Statut
          </small>

          <div>

            <span
              :class="
                moyen.isEnabled
                  ? 'badge bg-success'
                  : 'badge bg-secondary'
              "
            >
              {{ moyen.isEnabled ? 'Activé' : 'Désactivé' }}
            </span>

          </div>

        </div>

      </div>


      <!-- ================= ACTIONS ================= -->
      <div class="d-flex justify-content-end gap-3 mt-4">

        <button
          class="btn btn-light border px-4 py-2"
          @click="cancel"
          :disabled="isLoading"
        >
          <i class="bi bi-x-circle me-1"></i>
          Annuler
        </button>


        <button
          class="btn btn-success btn-boutique px-4 py-2"
          :disabled="isLoading"
          @click="updateMoyen"
        >

          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm me-2"
          ></span>

          <i
            v-else
            class="bi bi-save me-1"
          ></i>

          {{ isLoading
            ? 'Modification...'
            : 'Enregistrer les modifications'
          }}

        </button>

      </div>

    </div>

  </div>

</template>


<script>

import api from '@/api'

export default {

  name: 'EditMoyenPaiement',


  data() {

    return {

      loadingData: true,

      isLoading: false,


      moyen: {

        id: null,

        nom: '',

        isEnabled: true,

        createdBy: null

      },


      error: {

        nom: ''

      }

    }

  },


  computed: {

    currentUser() {

      return this.$store.getters.user

    },


    moyenId() {

      return this.$route.params.id

    }

  },


  methods: {

    /* ==============================
       CHARGER LE MOYEN
    ============================== */

    async getMoyen() {

      try {

        this.loadingData = true

        const response = await api.getItem(
          'moyen_paiements',
          this.moyenId
        )

        const data = response.data


        this.moyen = {

          id: data.id,

          nom: data.nom || '',

          isEnabled:
            data.isEnabled !== undefined
              ? data.isEnabled
              : true,

          createdBy:
            data.createdBy ?? null

        }

      } catch (e) {

        console.error(
          'Erreur lors du chargement du moyen de paiement :',
          e
        )

        alert(
          "Impossible de charger le moyen de paiement."
        )

        this.$router.push({
          name: 'liste_moyen_paiement'
        })

      } finally {

        this.loadingData = false

      }

    },


    /* ==============================
       VALIDATION
    ============================== */

    validateForm() {

      this.error.nom =
        this.moyen.nom &&
        this.moyen.nom.trim()
          ? ''
          : 'Le nom est obligatoire'

      return !this.error.nom

    },


    /* ==============================
       MODIFICATION
    ============================== */

    async updateMoyen() {

      if (!this.validateForm() || this.isLoading) {
        return
      }


      this.isLoading = true


      try {

        const payload = {

          nom: this.moyen.nom.trim(),

          isEnabled: this.moyen.isEnabled,

          createdBy:
            this.moyen.createdBy ??
            this.currentUser?.id ??
            null

        }


        await api.updateItem(
          'moyen_paiements',
          this.moyenId,
          payload
        )


        //alert( 'Moyen de paiement modifié avec succès.')


        this.$router.push({
          name: 'liste_moyen_paiement'
        })


      } catch (e) {

        console.error(
          'Erreur lors de la modification :',
          e
        )

        console.error(
          'Réponse API :',
          e.response?.data
        )


        alert(
          "Erreur lors de la modification du moyen de paiement."
        )

      } finally {

        this.isLoading = false

      }

    },


    /* ==============================
       ANNULER
    ============================== */

    cancel() {

      this.$router.push({
        name: 'liste_moyen_paiement'
      })

    }

  },


  /* ==============================
     INITIALISATION
  ============================== */

  created() {

    if (!this.moyenId) {

      alert(
        "Identifiant du moyen de paiement introuvable."
      )

      this.$router.push({
        name: 'liste_moyen_paiement'
      })

      return

    }


    this.getMoyen()

  }

}

</script>


<style scoped>

/* ================= BOUTIQUE STYLE ================= */

.payment-page {

  background: #f5f7fb;

  min-height: 100vh;

}


/* ================= HEADER ================= */

.header-boutique {

  background: linear-gradient(
    135deg,
    #064e3b,
    #10b981
  );

  color: white;

  padding: 20px;

  border-radius: 18px;

}


/* ================= CARD ================= */

.card-boutique {

  border: none;

  border-radius: 18px;

}


/* ================= INPUT ================= */

.form-control-boutique {

  border-radius: 12px;

  border: 1px solid #dbe3ec;

  padding: 10px 14px;

}


.form-control-boutique:focus {

  border-color: #10b981;

  box-shadow: 0 0 6px #10b98133;

}


/* ================= BUTTON ================= */

.btn-boutique {

  border-radius: 12px;

  background: linear-gradient(
    135deg,
    #064e3b,
    #10b981
  );

  border: none;

  color: white;

}


/* ================= SWITCH ================= */

.form-check-input {

  cursor: pointer;

}


.form-check-input:checked {

  background-color: #10b981;

  border-color: #10b981;

}

</style>
